<template>
  <div>
    <PageTitle
      title="Incomes"
      :btnCreate="true"
      :createPopup="true"
      permission="Income Create"
      @onClickCreate="openCreate"
    />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content mb-2">
        <v-row class="ma-0 align-right">
          <TableFilters
            :filters="['search', 'incomeFor', 'incomeCategory', 'dateRange']"
            v-model="filter"
            :columns="columns"
          />
        </v-row>
      </v-card>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <IncomeCreate
          :Income="income"
          :visible="createVisible"
          @close="createVisible = false"
          @afterSave="refreshData"
        />
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="rows"
          class="row-pointer"
          item-key="id"
          hide-default-footer
        >
          <template v-slot:item.date="{ item }">
            {{ item.date | formatDate }}
          </template>
          <template v-slot:item.amount="{ item }">
            {{ item.amount | formatCurrency }}
          </template>
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="incomes"
              :item="item"
              editPermission="Income Edit"
              viewPermission="Income Show"
              :isEditModal="true"
              :isSubViewModal="true"
              @onEditClicked="openEdit(item)"
              @onSubViewClicked="openView(item)"
            />
          </template>
          <template slot="body.append" v-if="rows.length">
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th class="text-right">{{ total | formatCurrency }}</th>
              <th></th>
            </tr>
          </template>
          <template v-slot:footer>
            <pagination
              url="incomes"
              @paginationOptions="setPaginationOptions"
              @response="receiveData"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>
        <IncomeEdit
          :visible="editVisible"
          :Income="income"
          @afterSave="refreshData"
          @close="editVisible = false"
        />
        <IncomeDetails
          :visible="viewVisible"
          :income="income"
          @close="viewVisible = false"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import TableFilters from "@/components/base/TableFilters";
import pagination from "@/modules/shared/components/pagination";
import IncomeCreate from "./IncomeCreate";
import IncomeEdit from "./IncomeEdit";
import IncomeDetails from "./IncomeDetails";
import { Income } from "@/models/Income";
import * as moment from "moment/moment";

export default {
  components: { TableFilters, pagination, IncomeCreate, IncomeEdit, IncomeDetails },
  data: () => ({
    paginationOptions: {},
    createVisible: false,
    editVisible: false,
    viewVisible: false,
    income: new Income(),
    rows: [],
    total: 0,
    columns: [
      { text: "Reference Number", value: "reference_number", show: true },
      { text: "Date", value: "date", show: true },
      { text: "Income For", value: "income_for", show: true },
      { text: "Income Category", value: "category.name", show: true },
      { text: "Amount", value: "amount", show: true, align: "right" },
      { text: "Actions", value: "action", show: true, align: "center" },
    ],
    filter: {
      search: "",
      incomeFor: "",
      incomeCategory: "",
      dateRange: "",
    },
  }),
  computed: {
    headers() {
      return this.columns.filter((item) => item.show);
    },
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    receiveData(data) {
      this.rows = data || [];
      this.total = this.rows.reduce((sum, row) => sum + Number(row.amount || 0), 0);
    },
    refreshData() {
      if (this.$refs.pagination) this.$refs.pagination.refreshData();
    },
    openCreate() {
      this.income = new Income();
      this.createVisible = true;
    },
    loadOne(id, done) {
      this.$store.dispatch("warehouse/GetIncome", id).then((res) => {
        const record = res.data || {};
        this.income = {
          ...record,
          date: record.date ? moment(record.date).format("YYYY-MM-DD") : null,
        };
        done();
      });
    },
    openEdit(item) {
      this.loadOne(item.id, () => {
        this.editVisible = true;
      });
    },
    openView(item) {
      this.loadOne(item.id, () => {
        this.viewVisible = true;
      });
    },
  },
};
</script>
